/*
 * Jira Ticket: PDL-364
 * Created Date: Mon, 30th Nov 2020, 13:33:21 pm
 * Author: Harry Crank
 * Email: harry.crank@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { ForgotPassword } from 'Layout/Auth';
import NotFound from './Layout/Error/NotFound';

export default [
  <Route path="/public/fonts/*" component={NotFound} />,
  <Route
    key="forgotPassword"
    exact
    noLayout
    path="/forgotPassword"
    render={(props) => <ForgotPassword {...props} />}
  />,
  <Route path="/plotSuspect" render={(props) => <Redirect to="/plot" />} />,
  <Route path="/plotEvidence" render={(props) => <Redirect to="/plot" />} />,
  // <Route path="/eventEvidence" render={(props) => <Redirect to="/event" />} />,
  <Route path="/eventSuspect" render={(props) => <Redirect to="/event" />} />,
];
